import { Phone } from "react-feather";
import { Button, Modal, ModalBody } from "reactstrap";
import { Href } from "../../../../../../Constants/Constants";
import { useAppDispatch, useAppSelector } from "../../../../../../ReduxToolkit/Hooks";
import { setAudioCall } from "../../../../../../ReduxToolkit/Reducers/Messenger/Messenger";
import { dynamicImage, Image } from "../../../../../../Utils";

const AudioCall= () => {
  const dispatch = useAppDispatch();
  const { audioCall } = useAppSelector((state) => state.messenger)
  return (
    <Modal isOpen={audioCall} fade toggle={() => dispatch(setAudioCall())} centered>
      <ModalBody className="p-0">
        <div className="audiocall1 call-modal">
          <Image className="bg-img img-fluid" src={dynamicImage("avtar/big/audiocall.jpg")} alt="Avatar" />
          <div className="center-con text-center">
            <div className="title2">Josephin water</div>
            <h6>log angelina california</h6>
            <ul>
              <li>
                <Button color="success" size="xl" tag={"a"} className="icon-btn button-effect is-animating font_label" onClick={() => dispatch(setAudioCall())} href={Href}>
                  <Phone />
                </Button>
              </li>
              <li>
                <Button color="danger" size="xl" tag={"a"} className="icon-btn button-effect is-animating font_label" onClick={() => dispatch(setAudioCall())} href={Href}>
                  <Phone />
                </Button>
              </li>
            </ul>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default AudioCall;
